export default __webpack_public_path__ + "static/cleo-f0a5afcb8115d866b808f747bcff07ef.png";